/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import {
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { Link } from "react-router-dom";
import Home from "./pages/Home";
import Settings from "./pages/Settings";
import StudentDetails from "./pages/StudentDetails";
import Login from "./Login";
import Attendance from "./pages/Attendance";
import Notifications from "./pages/Notifications";
import ProtectedRoute from "./ProtectedRoute";
import "./App.css";
import Exam from "./pages/Exam";
import Dummy from "./pages/Dummy";
import AttendanceFrom from "./pages/AttendanceFrom";
import { Toaster } from "react-hot-toast";
import StudentDetailsList from "./pages/StudentDetailsList";
import { SplashScreen } from "@capacitor/splash-screen";
import StudentExamDetails from "./pages/StudentExamDetails";
import Profile from "./pages/Profile";
import ParticularStudentDetails from "./pages/ParticularStudentDetails";
import { useAuth } from "./context/AuthContext";
import Questions from "./pages/Questions";
import PaperDetails from "./PaperDetails";
import PaperDetailsIn from "./pages/PaperDetailsIn";
import DownloadPaper from "./pages/DownloadPaper";
import PickQuestions from "./pages/PickQuestions";
import ChapterList from "./pages/ChapterList";
import VerifiedQuestions from "./pages/VerifiedQuestions";
import UnverifiedQuestions from "./pages/UnverifiedQuestions";
import TeacherAttendance from "./pages/TeacherAttendance";
import TeacherAttendanceForm from "./pages/TeacherAttendanceForm";
import SelectRoleForTeacher from "./pages/SelectRoleForTeacher";
import QuestionBank from "./pages/QuestionBank";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, loading } = useAuth();

  useEffect(() => {
    setTimeout(() => {
      SplashScreen.hide();
    }, 3000);
  }, []);

  useEffect(() => {
    if (loading) return;
    if (!isLoggedIn) {
      navigate("/login");
    } else if (location.pathname === "/login") {
      navigate("/home");
    }
  }, [isLoggedIn, location.pathname, navigate, loading]);

 const hideMenuRoutes = [
  "/login",
  "/attendance",
  "/student-details-list",
  "/student-details/exam-details/:id",
  "/student-details/particlar-student-details/:id/:seid",
  "/verified-questions", // <-- Add this line
];

const hideFooterRoutes = [
  "/login",
  "/attendance",
  "/teacher-attendance",
  "/attendance-form",
  "/teacher-attendance-form",
  "/student-details-list",
  "/verified-questions",
  "/unverified-questions",
  "/chapter-list/:id",
  "/paper"
];




const shouldHideFooter =
  hideFooterRoutes.includes(location.pathname) ||
  location.pathname.startsWith("/student-details/exam-details/") ||
  location.pathname.startsWith("/student-details/particlar-student-details/") ||
  location.pathname.startsWith("/pick-questions/");
  location.pathname.startsWith("/chapter-list");

  return (
    <div className="App">
      {!shouldHideFooter && (
        <div className="header-area" id="headerArea">
          <div className="container">
            <div className="header header-style-five position-relative d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="logo-wrapper me-2">
                  <Link to="/home">
                    <img
                      src="assets/img/bg-img/Untitled (Logo).png"
                      alt="Logo"
                      style={{ width: "60px", height: "65px" }}
                    />
                  </Link>
                </div>
                <div
                  className="logo-text user-data-card"
                  style={{ padding: "20px 0 10px 0", marginLeft: "-5px" }}
                >
                  <h6
                    style={{ margin: 0, fontSize: "14px", fontWeight: "bold" }}
                  >
                    Sarvajna &
                  </h6>
                  <h6
                    style={{ margin: 0, fontSize: "14px", fontWeight: "bold" }}
                  >
                    Justice Shivaraj Patil
                  </h6>
                  <h6
                    style={{ margin: 0, fontSize: "12px", fontWeight: "300" }}
                  >
                    PU College of Science
                  </h6>
                </div>
              </div>
              <div className="form-label">
                <Link to="/settings" style={{ fontSize: "12px" }}>
                  <i className="bi bi-list" style={{ fontSize: "24px" }}></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

    {!shouldHideFooter && (
        <div className="footer-nav-area" id="footerNav">
          <div className="container px-0">
            <div className="footer-nav position-relative">
              <ul className="h-100 d-flex align-items-center justify-content-between ps-0">
                <li>
                  <Link to="/home" style={{ fontSize: "12px" }}>
                    <i className="bi bi-house" style={{ fontSize: "24px" }}></i>
                    <span>Home</span>
                  </Link>
                </li>
                <li>
                  <Link to="/student-details">
                    <i
                      className="bi bi-mortarboard-fill"
                      style={{ fontSize: "24px" }}
                    ></i>
                    <span>Students</span>
                  </Link>
                </li>
                <li>
                  <Link to="/attendance-form">
                    <i
                      className="bi bi-pencil-square"
                      style={{ fontSize: "24px" }}
                    ></i>
                    <span>Attendance</span>
                  </Link>
                </li>
                <li>
                  <Link to="/notifications">
                    <i
                      className="bi bi-bell-fill"
                      style={{ fontSize: "24px" }}
                    ></i>
                    <span>Updates</span>
                  </Link>
                </li>
                <li>
                  <Link to="/settings">
                    <i className="bi bi-gear" style={{ fontSize: "24px" }}></i>
                    <span>Settings</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {!loading && (
        <Routes>
          <Route
            path="/login"
            element={isLoggedIn ? <Navigate to="/home" replace /> : <Login />}
          />
          <Route
            path="*"
            element={<Navigate to={isLoggedIn ? "/home" : "/login"} replace />}
          />
          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<Home />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/student-details" element={<StudentDetails />} />
            <Route
              path="/student-details/particlar-student-details/:id/:seid"
              element={<ParticularStudentDetails />}
            />
            <Route
              path="/student-details-list"
              element={<StudentDetailsList />}
            />

             <Route path="/chapter-list/:id" element={<ChapterList />} />
            <Route path="/question-bank" element={<QuestionBank />} />

            <Route path="/questions" element={<Questions />} />
            <Route path="/paper" element={<PaperDetails />} />

             <Route path="/verified-questions" element={<VerifiedQuestions />} />

                          <Route path="/unverified-questions" element={<UnverifiedQuestions />} />


            <Route path="/download/:id" element={<DownloadPaper />} />

   <Route path="/pick-questions/:id" element={<PickQuestions />} />
            <Route path="/paper-details/:id" element={<PaperDetailsIn />} />
            <Route path="/attendance-form" element={<AttendanceFrom />} />
            <Route path="/teacher-attendance-form" element={<TeacherAttendanceForm />} />

            <Route path="/attendance" element={<Attendance />} />
              <Route path="/teacher-attendance" element={<TeacherAttendance />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/exam" element={<Exam />} />
            <Route path="/dummy" element={<SelectRoleForTeacher />} />
          </Route>
        </Routes>
      )}
      <Toaster />
    </div>
  );
}

export default App;
